<div>
  <form [formGroup]="addressFormGroup" appTrackForm>
    <div class="address-tabs mt-2">
      <mat-label><span translate>Address type</span></mat-label>
      <div class="toggle-container mt-1" formGroupName="addressBtnsFormGroup">
        <mat-button-toggle-group
          #group="matButtonToggleGroup"
          multiple="false"
          formControlName="addressBtns"
          [hideSingleSelectionIndicator]="true"
          [value]="addressSelectedIndex"
          [(ngModel)]="addressSelectedIndex"
        >
          @for (array of addressTypesButtons; track array) {
            <mat-button-toggle
              class="address-btn"
              (change)="onBuildingTypeChange(array.id)"
              [value]="array.id"
            >
              <div class="tab-text">
                <!-- <mat-icon>{{ array.icon }}</mat-icon> -->
                <span class="tab-title">{{ array.name | translate }}</span>
              </div>
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>
    </div>
    <!-- <mat-form-field>

  </mat-form-field> -->
    <!--Address Section-->
    <section>
      <div class="form-row m-top-25 row">
        <div class="form-group col-md-6">
          <mat-label translate>Area</mat-label>
          <mat-form-field appearance="outline">
            <input
              matInput
              [placeholder]="'Area' | translate"
              formControlName="areaBuilding"
            />
          </mat-form-field>
        </div>
        <div class="form-group col-md-6">
          <mat-label>{{ getBuildingNameTitle() }}</mat-label>
          <mat-form-field appearance="outline">
            <input
              matInput
              [placeholder]="getBuildingNameTitle()"
              formControlName="buildingNameBuilding"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="form-row row">
        <div class="form-group col-md-6">
          <mat-label
            ><span translate>Floor Number</span>
            {{ addressSelectedIndex === 1 ? '' : ('(Optional)' | translate) }}
          </mat-label>
          <mat-form-field appearance="outline">
            <input
              matInput
              placeholder="{{ 'Floor Number' | translate }}"
              formControlName="floorBuilding"
            />
          </mat-form-field>
        </div>
        <div class="form-group col-md-6">
          <mat-label><span translate>Unit Number (Optional)</span></mat-label>
          <mat-form-field appearance="outline">
            <input
              matInput
              placeholder="{{ 'Unit Number' | translate }}"
              formControlName="unitBuilding"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="inline-div full-width">
        <div class="full-width form-group">
          <mat-label translate>Notes</mat-label>
          <mat-form-field appearance="outline">
            <textarea
              matInput
              [placeholder]="'Ex. drop with the security...' | translate"
              formControlName="noteBuilding"
            ></textarea>
            <mat-hint>
              <span translate>Note cannot exceed 255 characters.</span>
            </mat-hint>
          </mat-form-field>
        </div>
      </div>
    </section>
  </form>
</div>
